export const inputBorderClasses = {
    primary: 'border border-slate-200 dark:border-neutral-700',
    secondary: 'border border-neutral-200 dark:border-neutral-700',
    danger: 'border border-danger-300',
    transparent: 'border-none',
};
